import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
    selector: 'app-user',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent implements OnInit {

  constructor(
    private authenticationService: AuthenticationService) { }

  ngOnInit(): void {
      this.authenticationService.validateCode();
  }
}

